import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1
	},
	paper: {
		padding: theme.spacing(1),
		textAlign: 'left',
		color: theme.palette.text.secondary
	}
}));

export default function AmendContractForm(props) {
	let { amendmentReason, amendmentNumber, amendmentDate, amendmentReasonIDs } = props;
	const classes = useStyles();
	let lblAmendmentReasonTitle = amendmentReason && amendmentReason.length > 0 ? 'Amendment Reasons' : 'Amendment Reasons are Loading....';

	const onCheckAmendmentReasons = checkboxItem => {
		let matchData = amendmentReasonIDs.find(rowReasonIDs => rowReasonIDs === checkboxItem);
		return matchData ? true : false;
	};

	return (
		<React.Fragment>
			<div className={classes.root}>
				<Grid container justify="center" spacing={1}>
					<Grid item xs={6}>
						<Paper className={classes.paper}>
							<TextField
								id="filled-read-only-input"
								label="Amendment Number"
								InputProps={{
									readOnly: true
								}}
								variant="filled"
								fullWidth={true}
								size="medium"
								style={{ paddingTop: '.5em' }}
								value={amendmentNumber}
							/>
						</Paper>
					</Grid>
					<Grid item xs={6}>
						<Paper className={classes.paper}>
							<MuiPickersUtilsProvider utils={DateFnsUtils} style={{ height: '3em' }}>
								<KeyboardDatePicker
									disableToolbar
									autoOk={true}
									disablePast={true}
									variant="inline"
									format="dd/MM/yyyy"
									margin="normal"
									label="Amendment Date"
									value={amendmentDate}
									KeyboardButtonProps={{
										'aria-label': 'change date',
										style: { outline: 'none' }
									}}
									style={{ height: '3em' }}
									onChange={props.onDateChange}
								/>
							</MuiPickersUtilsProvider>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<label>{lblAmendmentReasonTitle}</label>
							<FormGroup row>
								{amendmentReason.map(item => {
									return (
										<FormControlLabel
											key={item.id}
											style={{ marginBottom: 'unset', width: '30%', marginLeft: '1em' }}
											control={
												<Checkbox
													name={item.description}
													checked={onCheckAmendmentReasons(item.id)}
													onChange={event => props.onReaonsCheckboxChange(event, item.id)}
												/>
											}
											label={item.description}
										/>
									);
								})}
							</FormGroup>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<button
								style={{
									height: '35px',
									width: '150px'
								}}
								onClick={props.onSubmitClick}
								className="react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
							>
								Submit
							</button>
						</Paper>
					</Grid>
				</Grid>
			</div>
		</React.Fragment>
	);
}

AmendContractForm.propTypes = {
	amendmentNumber: PropTypes.number.isRequired
};
